import { render, staticRenderFns } from "./allowedTimes.vue?vue&type=template&id=5e6096fa&scoped=true&"
import script from "./allowedTimes.vue?vue&type=script&lang=js&"
export * from "./allowedTimes.vue?vue&type=script&lang=js&"
import style0 from "./allowedTimes.vue?vue&type=style&index=0&id=5e6096fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6096fa",
  null
  
)

export default component.exports